import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IClient } from '@techspert-io/clients';
import { IEngagement } from '@techspert-io/engagements';
import {
  ExpertRequestStatus,
  ExpertRequestType,
  getExpertRequestStatus,
  IDisplayExpert,
} from '@techspert-io/experts';
import { IOpportunity } from '@techspert-io/opportunities';

@Component({
  selector: 'app-expert',
  templateUrl: './expert.component.html',
  styleUrls: ['./expert.component.scss'],
  standalone: false,
})
export class ExpertComponent {
  @Input() client: IClient;
  @Input() opportunity: IOpportunity;
  @Input() expert: IDisplayExpert;
  @Input() index: number;
  @Input() openFilter: boolean;
  @Input() showAffiliations: boolean;
  @Output() selectExpertSignal = new EventEmitter<IDisplayExpert>();
  @Output() toggleAdminRejectStatusSignal = new EventEmitter<IDisplayExpert>();
  @Output() navigateToExpertSignal = new EventEmitter<IDisplayExpert>();
  @Output() addExpertiseToSearchSignal = new EventEmitter<string>();
  @Output() showExpertScreenerSignal = new EventEmitter();
  @ViewChild('FullEmailList')
  public fullEmailList: ElementRef;
  public showActions: boolean = false;

  get expertName(): string {
    return [this.expert.firstName, this.expert.lastName]
      .filter(Boolean)
      .join(' ');
  }

  get expertAlias(): string {
    if (!this.expert.firstNameAlias && !this.expert.lastNameAlias) {
      return;
    }

    return [this.expert.firstNameAlias, this.expert.lastNameAlias]
      .filter(Boolean)
      .join(' ');
  }

  get identityVerificationRequestLastSent() {
    return this.getRequestLastSent(ExpertRequestType.IdentityVerification);
  }

  get additionalAvailabilityRequestLastSent() {
    return this.getRequestLastSent(ExpertRequestType.AdditionalAvailability);
  }

  public getEngagementStatusColor(engagement: IEngagement): string {
    if (!engagement.paymentActive) {
      return 'darkgrey';
    }
    if (engagement.paymentType === 'thirdParty') {
      return 'olive';
    }
    if (engagement.paymentStatus === 'not-paid') {
      return 'dodgerblue';
    }
    if (engagement.paymentStatus === 'payment-sent') {
      return 'darkorange';
    }
    if (engagement.paymentStatus === 'payment-received') {
      return 'mediumseagreen';
    }
    if (engagement.paymentStatus === 'not-claimed') {
      return 'indianred';
    }
  }

  public emitSelectExpertSignal(expert: IDisplayExpert): void {
    this.selectExpertSignal.emit(expert);
  }

  public emitToggleAdminRejectStatusSignal(): void {
    this.showActions = false;
    this.toggleAdminRejectStatusSignal.emit(this.expert);
  }

  public emitNavigateToExpertSignal(expert: IDisplayExpert): void {
    this.navigateToExpertSignal.emit(expert);
  }

  public toggleShowActions(event: Event): void {
    event.stopPropagation();
    this.showActions = !this.showActions;
  }

  public closeActions(): void {
    this.showActions = false;
  }

  public emitAddExpertiseToSearchSignal(expertise: string): void {
    this.addExpertiseToSearchSignal.emit(expertise);
  }

  public emitShowScreenerResults(): void {
    this.showExpertScreenerSignal.emit();
  }

  private getRequestLastSent(type: ExpertRequestType) {
    const requestStatus = getExpertRequestStatus(type, this.expert?.requests);

    if (requestStatus?.status === ExpertRequestStatus.Pending) {
      return requestStatus.lastSent;
    }
  }
}
